import styled from 'styled-components';
import { colors } from '../styles/variables';

type IField = {
  noLeftBorder?: boolean,
  noRightBorder?: boolean,
}

const FieldGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: stretch;
  background-color: ${colors.white};;
  width: 100%;
  margin-bottom: 0.25em;
  > div:first-of-type {
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
    border-left: 1px solid ${colors.gray300};
  }
  > div:last-of-type {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
    border-right: 1px solid ${colors.gray300};
  }
`;

const FieldGroupLabel = styled.div`
  line-height: 40px;
  font-size: 0.9em;
  padding: 0 1em;
  display: inline-block;
  text-align: center;
  white-space: nowrap;
  background-color: ${colors.gray200};
  border-top: 1px solid ${colors.gray300};
  border-bottom: 1px solid ${colors.gray300};
`;

const FieldLabel = styled.div`
  font-size: 14px;
  margin: 0;
  margin-bottom: 0.5em;
  font-weight: 600;
  color: ${colors.gray600};
`;

const Field = styled.div<IField>`
  position: relative;
  flex: 1;
  border-top: 1px solid ${colors.gray300};
  border-bottom: 1px solid ${colors.gray300};
  border-left: ${props => props.noLeftBorder ? 'none' : `1px solid ${colors.gray300}`};
  border-right: ${props => props.noRightBorder ? 'none' : `1px solid ${colors.gray300}`};
  border-top-left-radius: ${props => props.noLeftBorder ? 0 : '4px'};
  border-bottom-left-radius: ${props => props.noLeftBorder ? 0 : '4px'};
  border-top-right-radius: ${props => props.noRightBorder ? 0 : '4px'};
  border-bottom-right-radius: ${props => props.noRightBorder ? 0 : '4px'};
  input, select {
    width: 100%;
    min-width: 80px;
    height: 40px;
    background-color: transparent;
    font-size: 16px;
    padding: 4px 16px;
    border: 0;
    -moz-border-radius: 0;
    -webkit-border-radius: 0;
    -webkit-appearance:none;
    border-radius: 0;
    outline: none;
  }
  &.dropdown {
    &:after {
      content: "";
      position: absolute;
      right: 8px;
      top: 16px;
      border: solid ${colors.gray800};
      border-width: 0 2px 2px 0;
      display: inline-block;
      padding: 2px;
      transform: rotate(45deg);
    }
  }
  &.no-dropdown {
    width: 100%;
    min-width: 80px;
    height: 42px;
    background-color: transparent;
    font-size: 16px;
    border-radius: 0;
  }
`;

export { FieldGroup, FieldGroupLabel, Field, FieldLabel };

